export default __webpack_public_path__ + "static/media/chat-map.ec510a4d.png";